exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dialog-card[data-v-73311e3b]{border-radius:12px;overflow:hidden}.dialog-toolbar[data-v-73311e3b]{background:linear-gradient(135deg,#1976d2,#1565c0)!important}.dialog-title[data-v-73311e3b]{font-size:18px;font-weight:500}.action-btn[data-v-73311e3b]{text-transform:none!important;border-radius:8px!important}", ""]);

// exports
